import React from 'react';
import { SITE } from '../../data/site';
import { StarDivider } from '../ui/StarDivider';
export function GiftCardVisual({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`chrome-plate relative flex aspect-[1.6/1] w-full flex-col justify-between overflow-hidden rounded-[10px] p-[clamp(1rem,2vw,1.75rem)] shadow-[0_30px_60px_-20px_rgba(0,0,0,0.6)] ring-1 ring-white/60 ${className}`} role="img" aria-label="HPP Training gift certificate" data-id="element-478" data-mp="2qml2d8ws2b66">
      <div className="flex items-start justify-between gap-4" data-id="element-479" data-mp="2uooc9t3st7pc">
        <img src={SITE.logo} alt="" className="h-[clamp(2rem,3vw,3rem)] w-auto" data-id="element-480" data-mp="2uq97lkxxsuo9" />
        <span className="font-display text-xs font-semibold uppercase tracking-[0.2em] text-navy" data-id="element-481" data-mp="39knuvxojaq8q">Gift Certificate</span>
      </div>
      <div data-id="element-482" data-mp="1f7ehvvws4mlq">
        <StarDivider tone="light" align="left" data-id="element-483" data-mp="1f74nzx8m5var" />
        <p className="mt-3 font-display text-[clamp(1.25rem,2.2vw,2.25rem)] font-bold uppercase leading-none text-navy" data-id="element-484" data-mp="1f7xxv72vd0x4">The Gift of Self-Defense</p>
        <p className="mt-2 text-sm text-steel" data-id="element-485" data-mp="3620tmsui1zw7">Good for any course or package</p>
      </div>
      <span className="absolute inset-x-0 bottom-0 h-1.5 bg-accent" aria-hidden="true" data-id="element-486" data-mp="3a3cc8eeyhkuw" />
    </div>;
}